export const API_URL = process.env.REACT_APP_API_URL as string;
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN as string;